<div class="flex flex-col justify-end">
  <button
    (click)="clickBankIdButton()"
    [attr.data-testid]="'button-bankid-' + type"
    class="bank-id-button"
    [disabled]="isRegistrationBlocked && type === BankidType.register"
  >
    <svg-icon src="/assets/logos/bankid.svg" svgClass="bank-id-button-icon"></svg-icon>
    <span class="bank-id-button-span">&nbsp;</span>
    {{ type + '.with-bankid' | translate }}
  </button>
  <ng-container *ngIf="type === BankidType.login && lang === 'cs'">
    <a
      class="cm-paragraph-address self-end text-16px"
      target="_blank"
      href="https://coinmate.io/cz/reset-hesla-na-coinmate/"
    >
      {{ 'login.bankid-help' | translate }}
    </a>
  </ng-container>
</div>
<ng-container *ngIf="isRegistrationBlocked && type === BankidType.register">
  <p class="display-paragraph" [innerHTML]="'signUp.bankid-blocked' | translate"></p>
</ng-container>
